"use client";
import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {Typography} from "@/shared/ui/data-display/typography";
import {assetPath} from "@/shared/utils/asset-path";

import "../styles/date-unavailable-alert.scss";

export function DateUnavailableAlert(): JSX.Element {
    const {t} = useTranslation("rental");
    const {t: tCommon} = useTranslation("common");

    return (
        <div className="date-unavailable-alert">
            <SmartImage
                src={assetPath("/images/icons/info.svg")}
                alt={tCommon("warning")}
                width={24}
                height={24}
                className="date-unavailable-alert__icon"
            />
            <div className="date-unavailable-alert__content">
                <Typography as="div" size={14} weight={600} className="date-unavailable-alert__title">
                    {t("dateUnavailable")}
                </Typography>
                <Typography as="div" size={12} weight={400} color="paragraph" className="date-unavailable-alert__message">
                    {t("dateUnavailableMessage")}
                </Typography>
            </div>
        </div>
    );
}
